import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { colorWithOpacity } from "../../util/utils";
import { BLUE_600, DARK_BLUE } from "../../themes/colors";

interface InfoBoxProps {
  text: string;
}

const InfoBox: React.FC<InfoBoxProps> = ({ text }) => {
  return (
    <Box
      className="flex rounded-md space-x-[0.625rem] p-2 mt-3 items-center"
      sx={{
        backgroundColor: colorWithOpacity(BLUE_600, 0.1),
      }}
    >
      <InfoOutlined
        color="primary"
        fontSize="small"
        test-id={"InfoOutlinedIcon"}
      />
      <Typography variant="body2" fontWeight={500} color={DARK_BLUE}>
        {text}
      </Typography>
    </Box>
  );
};

export { InfoBox };
